// Modules Alpha optionnels fournis par le thème enfant.
// Le gestionnaire de modules Alpha (AlphaModuleManager) importe ces fichiers à la place de ceux du parent ;
// un module est activé dans config/modules.yaml (`<module>.enabled: true`) ou via data-alpha-required-modules.
window.alphaModulesOverrides = {
  ...window.alphaModulesOverrides || {},
  diagnosticSteps: () => import(/* webpackChunkName: "module-diagnostic-steps" */ '../alpha-modules/optional/diagnostic-steps'),
  faqFilters: () => import(/* webpackChunkName: "module-faq-filters" */ '../alpha-modules/optional/faq-filters'),
  googleBadge: () => import(/* webpackChunkName: "module-google-badge" */ '../alpha-modules/optional/google-badge'),
  mouseGlow: () => import(/* webpackChunkName: "module-mouse-glow" */ '../alpha-modules/optional/mouse-glow'),
  themeToggle: () => import(/* webpackChunkName: "module-theme-toggle" */ '../alpha-modules/optional/theme-toggle')
}
